<template>
    <div class="row wrap">
        <div class="col-12">
            <div class="title-buttons">
                <div class="title" v-if="points.length <= 0">
                    {{$t('No point')}}
                </div>
                <div class="title" v-else>
                    {{points.length}} {{$t('Points')}}
                </div>
                <div class="buttons">
                    <btn square @click="startDraw" v-if="!label.isDrawing && points.length <= 0">
                        <tooltip :text="$t('Start drawing')" position="left">
                            <i class="fal fa-pen-nib"></i>
                        </tooltip>
                    </btn>
                    <btn active link @click="stopDraw" v-if="label.isDrawing">
                        Stop
                    </btn>
                </div>
            </div>
            <p v-if="label.isDrawing" class="help">
                {{$t('Set points directly on the picture for create an area')}}
            </p>
        </div>
        <div v-for="(point,k) in points"
             :key="k"
             class="areas-point col-12 row align-end"
             :class="{'areas-edit-hover-point':point.hover}"
             @mouseenter="hoverPointer(k)"
             @mouseleave="unhoverPointer(k)"
        >
            <div class="col-5">
                <input-text v-model="point.x" :label="$t('Coord X')" after="px"/>
            </div>
            <div class="col-5">
                <input-text v-model="point.y" :label="$t('Coord Y')" after="px"/>
            </div>
            <div class="col-2 flex justify-end">
                <tooltip :text="$t('Delete point')" position="left" delay=".3s">
                    <btn square link remove @click="remove(k)">
                        <i class="fal fa-trash"></i>
                    </btn>
                </tooltip>
<!--                <vx-tooltip :text="$t('Insert point after')" position="left" delay=".3s">-->
<!--                    <btn square @click="add(k)">-->
<!--                        <i class="fal fa-plus"></i>-->
<!--                    </btn>-->
<!--                </vx-tooltip>-->
            </div>
        </div>
    </div>
    
</template>

<script>
    import InputText from "@/modules/input/input-text";
    import Btn from "@/modules/buttons/btn";
    import Tooltip from "@/modules/tooltip";

    export default {
        name: "Areas_Edit",
        components: {Tooltip, Btn, InputText},
        props: {
            label: {},
        },
        methods:{
            // add(k){
            //     let current = this.label.points[k];
            //     let next = this.label.points[k+1];
            //     if(!next){
            //         next = this.label.points[0];
            //     }
            //
            //     this.label.points.splice(k+1,0,{
            //         x:(current.x + next.x) / 2,
            //         y:(current.y + next.y) / 2
            //     })
            // },
            remove(k){
                this.label.points.splice(k,1)
                
                this.label.save();
            },
            hoverPointer(k){
                let point = this.label.points[k]
                point.hover = true;
                this.$set(this.label.points,k,point)
            },
            unhoverPointer(k) {
                let point = this.label.points[k]
                point.hover = false;
                this.$set(this.label.points, k, point)
            },
            startDraw(){
                this.label.draw();
            },
            stopDraw(){
                this.label.undraw();
                
                this.label.save();
            },
        },
        computed:{
            points(){
                return this.label.points;
            }
        },
    }
</script>

<style scoped>
    .areas-edit-hover-point{
        background: #323232;
    }
</style>